var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (config, continueBtnText, doneText, hasNarration, hasPrompt, i18n, playinline, prompt, submitUp, title, undefined, videos) {
jade_mixins["video-stream"] = jade_interp = function(videoUrl, playsinline, controls, klass, poster){
var block = (this && this.block), attributes = (this && this.attributes) || {};
playinline = playinline || true
controls = controls || true
klass = klass || 'video vjs-fluid'
var cloudinaryVideoFolderUrl = config.CLOUDINARY_CDN_URL+config.CLOUDINARY_VIDEO_FOLDER
var streamUrl = ''
if ( videoUrl && videoUrl.indexOf(cloudinaryVideoFolderUrl) > -1)
{
streamUrl = videoUrl.replace(cloudinaryVideoFolderUrl, cloudinaryVideoFolderUrl+'sp_full_hd/')
streamUrl = streamUrl.replace('.mp4', '.m3u8')
}
buf.push("<video" + (jade.attr("webkit-playsinline", playsinline, true, false)) + (jade.attr("controls", controls, true, false)) + " preload=\"auto\"" + (jade.attr("dir", config.direction, true, false)) + (jade.attr("poster", poster, true, false)) + (jade.cls(['video-js',klass], [null,true])) + "><source" + (jade.attr("src", videoUrl, true, false)) + "/>");
if ( streamUrl)
{
buf.push("<source" + (jade.attr("src", streamUrl, true, false)) + "/>");
}
buf.push("</video>");
};
buf.push("<div class=\"tappies-parent block-v-lg content-fill text-center\"><div class=\"thumbnail-collection content-fill clearfix\"><div class=\"content\"><h1 class=\"title slide-down delay-3 tight block-v-md\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</h1><div class=\"tappies row\">");
// iterate videos
;(function(){
  var $$obj = videos;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var video = $$obj[i];

var double = "col-sm-6";
var single = "col-md-8 col-md-offset-2 col-sm-12";
buf.push("<div" + (jade.attr("data-index", i, true, false)) + (jade.cls(['tappy','slide-up','block-v-sm','block-box-sizing',"delay-" + (i + 1) + " " + (videos.length >= 4 ? double : single) + ""], [null,null,null,null,true])) + "><div" + (jade.attr("style", (
                video.thumbnail && "background-image:url(" + (video.thumbnail) + ")"
              ), true, false)) + (jade.cls(['tappy-child','block-dk',(video.thumbnail && video.title) ? "dark" : ""], [null,null,true])) + ">");
if ( video.title)
{
buf.push("<div class=\"thumb-content text-lg text-bold block-md block-box-sizing\">" + (null == (jade_interp = video.title) ? "" : jade_interp) + "</div>");
}
buf.push("</div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var video = $$obj[i];

var double = "col-sm-6";
var single = "col-md-8 col-md-offset-2 col-sm-12";
buf.push("<div" + (jade.attr("data-index", i, true, false)) + (jade.cls(['tappy','slide-up','block-v-sm','block-box-sizing',"delay-" + (i + 1) + " " + (videos.length >= 4 ? double : single) + ""], [null,null,null,null,true])) + "><div" + (jade.attr("style", (
                video.thumbnail && "background-image:url(" + (video.thumbnail) + ")"
              ), true, false)) + (jade.cls(['tappy-child','block-dk',(video.thumbnail && video.title) ? "dark" : ""], [null,null,true])) + ">");
if ( video.title)
{
buf.push("<div class=\"thumb-content text-lg text-bold block-md block-box-sizing\">" + (null == (jade_interp = video.title) ? "" : jade_interp) + "</div>");
}
buf.push("</div></div>");
    }

  }
}).call(this);

buf.push("</div></div></div></div>");
// iterate videos
;(function(){
  var $$obj = videos;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var video = $$obj[i];

buf.push("<div class=\"video-details content-fill\"><div class=\"full-screen\"><span class=\"exit-video block-md icon icon-close text-xl\"></span></div><div class=\"full-screen video-container\">");
jade_mixins["video-stream"](video.url, true, true, "video vjs-fluid multi-content");
buf.push("</div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var video = $$obj[i];

buf.push("<div class=\"video-details content-fill\"><div class=\"full-screen\"><span class=\"exit-video block-md icon icon-close text-xl\"></span></div><div class=\"full-screen video-container\">");
jade_mixins["video-stream"](video.url, true, true, "video vjs-fluid multi-content");
buf.push("</div></div>");
    }

  }
}).call(this);

buf.push("<div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"config" in locals_for_with?locals_for_with.config:typeof config!=="undefined"?config:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"playinline" in locals_for_with?locals_for_with.playinline:typeof playinline!=="undefined"?playinline:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined,"videos" in locals_for_with?locals_for_with.videos:typeof videos!=="undefined"?videos:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}